import { BufferAttribute, BufferGeometry } from 'three'
import type asset from '../../SourceArt/PierBackbox/mesh.json'
import { bodyLengthFor, type CabinetDimensions } from './cabinet'
let data: typeof asset | undefined
export async function prepareAuthoredBackbox(): Promise<void> { data ??= (await import('../../SourceArt/PierBackbox/mesh.json')).default }
/** The lower rebate separates overlapping flank faces without moving the artwork or head. */
export function authoredBackbox(id: string | undefined, d: CabinetDimensions): BufferGeometry | undefined {
  const t=data?.tables.find(t=>t.machineId===id)
  if(!t || Math.abs(t.cabinetWidth-d.width)>1e-8 || Math.abs(t.cabinetHeight-d.height)>1e-8
    ||Math.abs(t.cabinetLength-bodyLengthFor(d))>1e-8 ||Math.abs(t.incline-d.incline)>1e-8
    ||Math.abs(t.backTopY-(d.lockdownBarHeight+Math.tan(d.incline)*bodyLengthFor(d)))>1e-8)return undefined
  const g=new BufferGeometry()
  g.setAttribute('position',new BufferAttribute(new Float32Array(t.positions),3))
  g.setAttribute('normal',new BufferAttribute(new Float32Array(t.normals),3))
  g.setAttribute('uv',new BufferAttribute(new Float32Array(t.uvs),2));g.setIndex(t.triangles)
  g.computeBoundingBox();g.computeBoundingSphere();return g
}
